import * as React from "react";
import { List } from "immutable";
import * as Selector from "../selector";
import State, { Status } from "../model";
import { Dispatch } from "redux";
import { AppAction } from "../actions";
import * as Actions from "../actions";
import { connect } from "react-redux";
import Face from "../face";
import { Row, Col } from "react-bootstrap";
import { dieFaceToElement } from "./dieFaceDisplay";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { X } from "../faces";
import { StateWithHistory, ActionCreators } from "redux-undo";

interface ActionProps {
    availableSevens: List<List<number>>;
    availableXLocations: List<number>;
    shownFaces: List<Face>;
    selectedSeven: List<number>;
    status: Status;
    canUndo: boolean;
    canRedo: boolean;

    dispatch: Dispatch<AppAction>;
}

/*
function dieString(face: Face): string {
    switch (face.type) {
        case "Pips": return "(Pips " + face.value + ")";
        case "Vp": return "(VP " + face.value + ")";
        case "X": return "(X)";
    }
    return "ERROR";
}
*/

function dieSpan(index: number, face: Face): JSX.Element {
    return <span className={"die" + index} key={"die" + index}>{dieFaceToElement(face, "2x")}</span>;
}

class ActionDisplay extends React.Component<ActionProps, {}> {
    private columnActions(dieIndex: number): JSX.Element {
        return <Col xs={2} key={dieIndex}>
            {this.props.status == "ROLLED" && this.props.availableSevens.count() > 0 && this.props.availableSevens.filter(seven => seven.indexOf(dieIndex) > -1).map((seven, i) => 
                <button onClick={() => this.props.dispatch(Actions.selectSeven(seven))} key={i}>{this.renderSeven(seven)}</button>)
            }
            {this.props.status == "ROLLED" && this.props.availableXLocations != undefined && this.props.availableXLocations.indexOf(dieIndex) > -1 &&
                <button onClick={() => this.props.dispatch(Actions.replaceX(dieIndex))} key={dieIndex}>{(dieSpan(dieIndex, this.props.shownFaces.get(dieIndex)))}<FontAwesomeIcon icon={faArrowRight} size="2x" />{dieSpan(dieIndex, X)}</button>}
            {this.props.status == "SEVEN_SELECTED" && this.props.selectedSeven.indexOf(dieIndex) > -1 && 
                <button key={"r" + dieIndex} onClick={() => this.props.dispatch(Actions.replaceSeven(dieIndex, this.props.selectedSeven.count() - 1))}>{dieSpan(dieIndex, this.props.shownFaces.get(dieIndex))}<FontAwesomeIcon icon={faArrowRight} size="2x" />{dieSpan(dieIndex, { type: "Vp", value: this.props.selectedSeven.count() - 1 })} </button>
            }
            {this.props.status == "READY_TO_BUMP" && (this.props.selectedSeven == undefined || this.props.selectedSeven.indexOf(dieIndex) == -1) &&  
                <span key="rtb">
                    {Selector.getIncreasedValue(this.props.shownFaces.get(dieIndex)) != undefined && 
                        <button key={"increase"} onClick={() => this.props.dispatch(Actions.bumpValue(dieIndex, Selector.getIncreasedValue(this.props.shownFaces.get(dieIndex))))}>{dieSpan(dieIndex, this.props.shownFaces.get(dieIndex))}<FontAwesomeIcon icon={faArrowRight} size="2x" />{dieSpan(dieIndex, Selector.getIncreasedValue(this.props.shownFaces.get(dieIndex)))}</button>
                    }
                    {Selector.getDecreasedValue(this.props.shownFaces.get(dieIndex)) != undefined && 
                        <button key={"decrease"} onClick={() => this.props.dispatch(Actions.bumpValue(dieIndex, Selector.getDecreasedValue(this.props.shownFaces.get(dieIndex))))}>{dieSpan(dieIndex, this.props.shownFaces.get(dieIndex))}<FontAwesomeIcon icon={faArrowRight} size="2x" />{dieSpan(dieIndex, Selector.getDecreasedValue(this.props.shownFaces.get(dieIndex)))}</button>
                    }
                </span>
            }
        </Col>
    }

    private firstColumnActions(): JSX.Element {
        return <Col xs={2} key={-1} >
            {this.props.status == "BEGIN" && <button onClick={() => this.roll()}>Roll</button>}
            {this.props.status == "READY_TO_BUMP" && <button onClick={() => this.props.dispatch(Actions.passBumpValue())}>Don't bump</button>}
            {this.props.status == "GAME_OVER" && <button onClick={() => {this.props.dispatch(Actions.newGame()); this.props.dispatch(ActionCreators.clearHistory())}}>New Game</button>}
            {this.props.canUndo && <button onClick={() => this.props.dispatch(ActionCreators.undo())}>Undo</button>}
            {this.props.canRedo && <button onClick={() => this.props.dispatch(ActionCreators.redo())}>Redo</button>}
        </Col>;
    }

    public render(): JSX.Element {
        return <Row>{this.firstColumnActions()}{[0, 1, 2, 3, 4].map(c => this.columnActions(c))}</Row>;
    }

    private renderSeven(seven: List<number>): JSX.Element {
        return <span key="k1">
            {seven.map(idx => <span className={"die" + idx}>&nbsp;{dieFaceToElement(this.props.shownFaces.get(idx), "2x")}&nbsp;</span>)}
        </span>
    }

    private roll(): void {
        this.props.dispatch(Actions.rollDice());
    }
}

const mapStateToProps = (state: StateWithHistory<State>, ownProps: {}) => {
    var faces = Selector.getRolledFaces(state.present);
    return {
        status: state.present.status,
        availableSevens: Selector.availableSevens(state.present),
        availableXLocations: Selector.availableXLocations(state.present),
        shownFaces: faces,
        selectedSeven: state.present.selectedSeven,
        canUndo: Selector.canUndo(state),
        canRedo: Selector.canRedo(state)
     };
}

const mapDispatchToProps = (dispatch: Dispatch<AppAction>) => ({ dispatch });

export default connect(mapStateToProps, mapDispatchToProps)(ActionDisplay);
